import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import { renderMarkdownBlocks } from '../presentation-components/display-elements-components/markdown-blocks';

function UserBubble({ content }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
      <Box
        sx={{
          maxWidth: '85%',
          bgcolor: 'secondary.light',
          color: 'text.primary',
          borderRadius: 4,
          borderBottomRightRadius: 1,
          px: 2,
          py: 1.25,
        }}
      >
        <Typography variant="body1" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
          {content}
        </Typography>
      </Box>
    </Box>
  );
}

// onUseDraft (optional): a page that can take the answer as the starting text of one of its own
// fields renders a button for it, labelled useDraftLabel. Absent, the message is unchanged.
function AssistantMessage({ message, onCopy, onUseDraft, useDraftLabel }) {
  return (
    <Box>
      {(message.warnings || []).map((warning, index) => (
        <Alert severity="warning" key={`${message.id}-warning-${index}`} sx={{ mb: 1 }}>
          {warning}
        </Alert>
      ))}
      <Box
        sx={{
          borderRadius: 4,
          p: 2,
          bgcolor: 'common.white',
          boxShadow: '0 8px 28px rgba(17, 30, 33, 0.08)',
        }}
      >
        {renderMarkdownBlocks(message.content)}
        <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 1 }}>
          {onUseDraft && (
            <Button
              variant="contained"
              size="small"
              onClick={() => onUseDraft(message.content)}
              sx={{ textTransform: 'none' }}
            >
              {useDraftLabel}
            </Button>
          )}
          <Button
            variant="text"
            size="small"
            startIcon={<ContentCopyOutlinedIcon fontSize="small" />}
            onClick={() => onCopy(message.content)}
            sx={{ textTransform: 'none' }}
          >
            Copy
          </Button>
        </Stack>
      </Box>
    </Box>
  );
}

export const CopilotMessageList = ({ messages = [], onCopy, onUseDraft, useDraftLabel = 'Use this text' }) => (
  <Stack spacing={2}>
    {messages.map((message) => (
      message.role === 'user'
        ? <UserBubble key={message.id} content={message.content} />
        : <AssistantMessage key={message.id} message={message} onCopy={onCopy} onUseDraft={onUseDraft} useDraftLabel={useDraftLabel} />
    ))}
  </Stack>
);
